export const DUPLICATED_BRANCH_NAME_MESSAGE =
  "Ya existe una sucursal con ese nombre en este consultorio.";

// Compara nombres sin distinguir mayúsculas, acentos ni espacios repetidos.
export const normalizeBranchName = (value) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const hasDuplicatedBranchName = (branches = [], branch) => {
  const name = normalizeBranchName(branch?.name);
  const branchId = Number(branch?.id || 0);
  const current = branches.find((item) => Number(item?.id) === branchId);

  // Solo se valida al crear o renombrar, para no bloquear sucursales que ya
  // estaban repetidas antes de esta validación.
  if (!name || (current && normalizeBranchName(current.name) === name)) {
    return false;
  }

  return branches.some(
    (item) =>
      Number(item?.id) !== branchId && normalizeBranchName(item?.name) === name,
  );
};
